// اضافه کردن کتابخانه ها به صفحه
import * as React from "react";
import {createSearchParams, Link, NavLink, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary, Divider, Drawer, FormControl, FormControlLabel, FormGroup, MenuItem, Select, Switch, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';


// Icon Import
// اضافه کردن آیکون به پروژه از طریق متریال ایکن
import {AllInbox, Cancel, Crop, ExpandMore, Menu, MiscellaneousServices, Home, CheckBox, Dashboard} from '@mui/icons-material';
// اضافه کردن svg به صفحه
import {ReactComponent as Delivery} from '../assets/img/icons/drawer/delivery.svg';
import {ReactComponent as PME} from '../assets/img/icons/drawer/pme.svg';
import {ReactComponent as Kadox} from '../assets/img/icons/drawer/kadox.svg';
import {ReactComponent as BioPost} from '../assets/img/icons/drawer/biopost.svg';
import {ReactComponent as Loadex} from '../assets/img/icons/drawer/loadex.svg';
import {ReactComponent as Shopex} from '../assets/img/icons/drawer/shopex.svg';
import {ReactComponent as Application} from '../assets/img/icons/drawer/app.svg';
import {ReactComponent as Support} from '../assets/img/icons/drawer/support.svg';
import {ReactComponent as Agency} from '../assets/img/icons/drawer/agency.svg';
import {ReactComponent as API} from '../assets/img/icons/drawer/api.svg';
import {ReactComponent as Transfer} from '../assets/img/icons/drawer/transfer.svg';
import {ReactComponent as Question} from '../assets/img/icons/drawer/question.svg';
import {ReactComponent as Setting} from '../assets/img/icons/drawer/setting.svg';
import {ReactComponent as Support1} from '../assets/img/icons/navBar/support.svg';
import {ReactComponent as LogOut} from '../assets/img/icons/drawer/logout.svg';


import {ThemeContext} from "../App";

import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {setLoading} from "../redux/loading/actions";
import {handleSetQuery} from "../assets/js/main";
import {useSnackbar} from "notistack";
import HandleFetchData from "../plugin/HandleFetchData";


export default function NavBar({blue, back, position}) {
  // گرفتن متغیر گلوبال از طریق useContext
  const theme = React.useContext(ThemeContext)
  const {enqueueSnackbar} = useSnackbar();
  const [searchParams] = useSearchParams();

  // استفاده از متود های i18n برای چند زبان کردن پروژه و تغییر زبان پروژه
  const {t, i18n} = useTranslation()
  // استفاده از useNavigate در react-router-dom برای جابجایی بین صفحات و ارسال اطلاعات به صفحات
  const navigate = useNavigate();
  // استفاده از useLocation در react-router-dom برای گرفتن اطلاعات صفحه جاری
  const location = useLocation();
  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const {fetchData} = HandleFetchData()
  const divarIncomId = searchParams.get('state')


  // متغیر و useState های لوکال صفحه
  const [drawer, setDrawer] = React.useState(false)
  const [expanded, setExpanded] = React.useState(false);
  const [service, setService] = React.useState(false);
  const [language, setLanguage] = React.useState(i18n.language);
  const [userInfo, setUserInfo] = React.useState(null)


  React.useEffect(() => {
    const tokenStorage = localStorage.getItem('token')
    if (localStorage.getItem('info-user') === "undefined" && !tokenStorage) {
      localStorage.removeItem("token")
      localStorage.removeItem("info-user")
      localStorage.removeItem("token-id")
      setUserInfo(null)
    } else if (localStorage.getItem('info-user') === "undefined" && tokenStorage) {
      getUserInfo()
    } else if (localStorage.getItem('info-user')) {
      setUserInfo(JSON.parse(localStorage.getItem('info-user')))
    }

    dispatch({type: 'RESET_STATE_SENDER_SINGLE'})
    dispatch({type: 'RESET_STATE_RECEIVER_SINGLE'})
    dispatch({type: 'RESET_STATE_BOX_SINGLE'})
    dispatch({type: 'RESET_STATE_REVIEW_SINGLE'})
    dispatch({type: 'RESET_STATE_SENDER_MULTI'})
    dispatch({type: 'RESET_STATE_RECEIVER_MULTI'})
    dispatch({type: 'RESET_STATE_BOX_MULTI'})

  }, [])


  const getUserInfo = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', `/getCustomerInfo`, '', 'application/json', '' , '', '')
    dispatch(setLoading(false))
    localStorage.setItem('info-user', JSON.stringify(fetch?.Data))
    setUserInfo(fetch?.Data)
  }

  const logOut = async () => {
    await localStorage.removeItem("token")
    await localStorage.removeItem("info-user")
    await localStorage.removeItem("token-id")
    await localStorage.setItem('access_login', false)
    navigate('/auth/login', {
      search: createSearchParams({
        state: location?.search
      }).toString(),
      replace: true
    })
  }

  // اضافه کردن Attribute به dom پروژه
  document.documentElement.setAttribute('lang', i18n.language);
  document.documentElement.setAttribute('dir', i18n.dir(i18n.language));

  // متد تغییر زبان پروژه و اضافه کردن زبان فعلی پروژه به متغیرهای لوکال صفحه
  const handleChangeLang = (event) => {
    i18n.changeLanguage(event.target.value);
    setLanguage(event.target.value);
  };

  // متود تغییر وضعیت Accordion در drawer
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleChangeService = (panel) => (event, isExpanded) => {
    setService(isExpanded ? panel : false);
  };

  // متد تغییر تم وب سایت
  const changeSwitch = (e) => {
    theme.toggleTheme(e.target.checked)
  }

  // استایل سفارشی سوئیچ اکشن تغییر تم وب سایت
  const MaterialUISwitch = styled(Switch)(({theme}) => ({
    padding: 8,

    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      backgroundColor: '#F7941D',
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
      },
      '&:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 20 20"><path fill="${encodeURIComponent('#fff',
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
        left: 12,
      },
      '&:after': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
           '#fff',
        )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
        right: 12,
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  return (
     <>
       <div className="navBarComponent">
         <div className="navBarMobile d-flex d-lg-none" style={position ? {position: 'absolute'} : {position: 'relative'}}>
           <div className="navBarItemsRight">
             <div className="navBarItem">
               <button onClick={() => setDrawer(true)} id="openDrawer">
                 <Menu fontSize="large" className={blue ? 'iconBlue' : 'iconWhite'}/>
               </button>
             </div>
           </div>

           {/*سوئیچ اکشن تغییر تم  وب سایت*/}
           {
             location.pathname === '/tracking' &&
             <div className="d-flex align-items-center">

               <div className="lang">
                 <FormControl>
                   <Select
                      id="language"
                      value={language}
                      onChange={handleChangeLang}
                      displayEmpty
                      inputProps={{'aria-label': 'Without label'}}
                   >
                     <MenuItem value="fa">فا</MenuItem>
                     <MenuItem value="en">En</MenuItem>
                   </Select>
                 </FormControl>
               </div>

               <div className="switchTheme">
                 <FormGroup>
                   <FormControlLabel
                      id="darkMode"
                      onChange={(e) => changeSwitch(e)}
                      control={<MaterialUISwitch sx={{m: 1}} checked={theme.darkMode}/>}
                   />
                 </FormGroup>
               </div>
             </div>
           }

           {
             location.pathname !== '/tracking' &&
             <div className="d-flex">
               {
                 location.pathname === '/singleOrder' && !divarIncomId &&
                 <Link to={{pathname: '/multiOrder', search: location?.search}} className="btn-tracking tracking-1" id="multiOrderNavTop">
                   <span>{t("navBar.t11")}</span>
                 </Link>
               }
               <Link to={{pathname: '/tracking', search: location?.search}} className="btn-tracking tracking-2" id="trackingNavTop">
                 <span>{t("navBar.t2")}</span>
               </Link>
             </div>
           }

         </div>


         {/*نوبار سایت در مود  دسکتاپ*/}
         <div className="navBarDesktop d-none d-lg-block">
           {/*<div className="container">*/}
           <div className="navBarItems">

             <div className="navBarDrawer">
               <button onClick={() => setDrawer(true)} id="openDrawer">
                 <Menu fontSize="large" className={blue ? 'iconBlue' : 'iconWhite'}/>
               </button>
             </div>

             {
               userInfo ?
                  <Link to={{pathname: '/dashboard', search: location?.search}} id="dashboardNavTop">
                    <div className="navBarLogin btnGroup_yellow">
                      <button className="btnFill">{userInfo?.FullName || userInfo?.Mobile}</button>
                    </div>
                  </Link>
                  :
                  <Link to={{pathname: '/auth/login', search: location?.search}} id="loginNavTop">
                    <div className="navBarLogin btnGroup_yellow">
                      <button className="btnFill">{t("navBar.t1")}</button>
                    </div>
                  </Link>
             }


             <nav className="navBarMenu">
               <div className="item">
                 <NavLink
                    id="trackingNavTop"
                    className={({isActive}) => isActive ? 'is-active' : ''}
                    to={{pathname: '/tracking', search: location?.search}}>
                   {t("navBar.t2")}
                 </NavLink>
               </div>
               <div className="item">
                 <NavLink
                    id="singleOrderNavTop"
                    className={({isActive}) => isActive ? 'is-active' : ''}
                    to={{pathname: '/singleOrder', search: location?.search}}>
                   {t("navBar.t3")}
                 </NavLink>
               </div>
               <div className="item">
                 <NavLink
                    id="multiOrderNavTop"
                    className={({isActive}) => isActive ? 'is-active' : ''}
                    to={{pathname: '/multiOrder', search: location?.search}}>
                   {t("navBar.t4")}
                 </NavLink>
               </div>
               <div className="item">
                 <NavLink
                    id="walletNavTop"
                    className={({isActive}) => isActive ? 'is-active' : ''}
                          to={{pathname: '/wallet', search: location?.search}}>
                   {t("navBar.t5")}
                 </NavLink>
               </div>
               <div className="item">
                 <NavLink
                    id="dashboardNavTop"
                    className={({isActive}) => isActive ? 'is-active' : ''}
                    to={{pathname: '/employment', search: location?.search}}>
                   {t("drawer.t24")}
                 </NavLink>

                 {/*<Link to={{pathname: '/employment', search: location?.search}} className="item" id="employmentNavTop"*/}
                 {/*>*/}
                 {/*  <CheckBox/>*/}
                 {/*  <p>{t("drawer.t24")}</p>*/}
                 {/*</Link>*/}
               </div>
             </nav>

             <NavLink to={{pathname: '/agencyRequest', search: location?.search}} className="navBarSupport" id="didarNavTop">
               <Support1/>
               <p>{t("navBar.t9")}</p>
             </NavLink>

             <div className="action">
               {/*دراپ داون تغییر زبان وب سایت*/}
               <div className="lang">
                 <FormControl>
                   <Select
                      id="language"
                      value={language}
                      onChange={handleChangeLang}
                      displayEmpty
                      inputProps={{'aria-label': 'Without label'}}
                   >
                     <MenuItem value="fa">فا</MenuItem>
                     <MenuItem value="en">En</MenuItem>
                   </Select>
                 </FormControl>
               </div>

               {/*سوئیچ اکشن تغییر تم  وب سایت*/}
               <div className="switchTheme">
                 <FormGroup>
                   <FormControlLabel
                      id="darkMode"
                      onChange={(e) => changeSwitch(e)}
                      control={<MaterialUISwitch sx={{m: 1}} checked={theme.darkMode}/>}
                   />
                 </FormGroup>
               </div>
             </div>

             <div className="navBarLogo">
               <NavLink to='/tracking' id="trackingNavTop">
                 <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt=""/>
               </NavLink>
             </div>

           </div>
           {/*</div>*/}
         </div>

         {/*drawer menu*/}
         <Drawer
            anchor={i18n.language === "en" ? 'left' : 'right'}
            open={drawer}
            onClose={() => setDrawer(false)}
            className="drawerMenu"
         >
           <div className="infoDrawer">
             {
               userInfo ?
                  <>
                    <img src={require('./../assets/img/user.png')} alt=""/>
                    <h5>{userInfo?.FullName || t("navBar.t8")}</h5>
                    <p>{userInfo?.Mobile || '-'}</p>
                    <p>{userInfo?.Email || '-'}</p>
                  </>
                  :
                  <Link to={{pathname: '/auth/login', search: location?.search}} id="loginNavTop">
                    <div className="navBarLogin btnGroup_yellow mt-5">
                      <button className="btnFill justify-content-center">{t("navBar.t1")}</button>
                    </div>
                  </Link>
             }

             <div className="closed">
               <button type="button" onClick={() => setDrawer(false)} id="closeDrawer">
                 <Cancel/>
               </button>
             </div>
           </div>

           <Divider/>

           <div className="itemDrawer">
             <Link to={{pathname: '/tracking', search: location?.search}} className="item align-items-end" id="trackingNavTop">
               <Home/>
               <p>{t("drawer.t23")}</p>
             </Link>
             <Link to={{pathname: '/dashboard', search: location?.search}} className="item align-items-end" id="trackingNavTop">
               <Dashboard/>
               <p>{t("navBar.t6")}</p>
             </Link>
             {
                process.env.REACT_APP_SITE === 'postex' &&
                <Accordion expanded={service === 'panel'} onChange={handleChangeService('panel')}>
                  <AccordionSummary
                     expandIcon={<ExpandMore/>}
                     aria-controls="panel1bh-content"
                     id="panel1bh-header"
                  >
                    <Typography>
                      <MiscellaneousServices/>
                      {t("drawer.t1")}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Link to="" className="item">
                      <Delivery/>
                      <p>{t("drawer.t2")}</p>
                    </Link>
                    <Link to="" className="item">
                      <PME/>
                      <p>{t("drawer.t3")}</p>
                    </Link>
                    <Link to="" className="item">
                      <Shopex/>
                      <p>{t("drawer.t4")}</p>
                    </Link>
                    <Link to="" className="item">
                      <Loadex/>
                      <p>{t("drawer.t5")}</p>
                    </Link>
                    <Link to="" className="item">
                      <BioPost/>
                      <p>{t("drawer.t6")}</p>
                    </Link>
                    <Link to="" className="item">
                      <Kadox/>
                      <p>{t("drawer.t7")}</p>
                    </Link>
                  </AccordionDetails>
                </Accordion>
             }

             <Link to={{pathname: '/orderList', search: location?.search}} className="item" id="orderListNavTop">
               <AllInbox/>
               <p>{t("drawer.t8")}</p>
             </Link>
             <Link to={{pathname: '/ordersOthers', search: location?.search}} className="item" id="ordersOthersNavTop">
               <AllInbox/>
               <p>{t("drawer.t22")}</p>
             </Link>
             {
                process.env.REACT_APP_SITE === 'postex' &&
             <Link to={{pathname: '/packing', search: location?.search}} className="item" id="packingNavTop">
               <Crop/>
               <p>{t("drawer.t9")}</p>
             </Link>
             }
             <a className="item" href="https://cafebazaar.ir/app/com.postex.app" target="_blank" id="cafeBazaarNavTop">
               <Application/>
               <p>{t("drawer.t10")}</p>
             </a>

             <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
               <AccordionSummary
                  expandIcon={<ExpandMore/>}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
               >
                 <Typography>
                   <Support/>
                   {t("drawer.t11")}
                 </Typography>
               </AccordionSummary>
               <AccordionDetails>
                 <Link to={{pathname: '/support', search: location?.search}} className="item" id="supportNavTop">
                   <p>{t("drawer.t12")}</p>
                 </Link>
                 <Link to={{pathname: '/support/list', search: location?.search}} className="item" id="supportListNavTop">
                   <p>{t("drawer.t13")}</p>
                 </Link>
               </AccordionDetails>
             </Accordion>

             <Link to={{pathname: '/agencyRequest', search: location?.search}} className="item" id="didarNavTop"
             >
               <Agency/>
               <p>{t("drawer.t14")}</p>
             </Link>

             <Link to={{pathname: '/employment', search: location?.search}} className="item" id="employmentNavTop"
             >
               <CheckBox/>
               <p>{t("drawer.t24")}</p>
             </Link>
             <a className="item" href="http://api.postex.ir/api-docs/index.html" target="_blank" id="apiNavTop">
               <API/>
               <p>{t("drawer.t16")}</p>
             </a>
             <a className="item" href="https://mag.postex.ir/" target="_blank" id="magNavTop">
               <Transfer/>
               <p>{t("drawer.t17")}</p>
             </a>

             <Link to={{pathname: '/faq', search: location?.search}} className="item" id="faqNavTop">
               <Question/>
               <p>{t("drawer.t19")}</p>
             </Link>

             <Divider/>

             <Link to={{pathname: '/settingAccount', search: location?.search}} className="item" id="settingAccountNavTop">
               <Setting/>
               <p>{t("drawer.t20")}</p>
             </Link>
             <button type="button" className="item" onClick={() => logOut()} id="logOut">
               <LogOut/>
               <p>{t("drawer.t21")}</p>
             </button>
           </div>

         </Drawer>
       </div>
     </>
  )
}
